import React from 'react';
import { SkeletonBlock } from '../../../../components/skeleton/skeleton';

const HEADERS_LEFT = [
  'Order#',
  'Date',
  'Company',
  'Status',
  'Subtotal',
  'Tax',
];
const HEADERS_RIGHT = [
  'Tip',
  'Card Fees',
  'Discount',
  'Fee',
  'Refund',
  'Service Charge',
  'Net Payout',
  'Stripe Net',
  'Total Amount',
];

function OrdersSummarySkeleton({ rows = 5, showStoreFees = false }) {
  const widths = [
    'w-16',
    'w-32',
    'w-24',
    'w-20',
    'w-16',
    'w-16',
    'w-16',
    'w-16',
    'w-16',
    'w-16',
    'w-16',
    'w-16',
    'w-20',
    'w-20',
    'w-20',
  ];

  return (
    <div className="reveal" aria-hidden="true">
      <table className="min-w-full divide-y divide-gray-300 dark:divide-slate-500">
        <thead>
          <tr>
            {HEADERS_LEFT.map((label, i) => (
              <th
                key={label}
                className={`py-3.5 px-4 text-left text-sm font-semibold text-slate-900 dark:text-slate-100 ${
                  i === 0 ? 'pl-0' : ''
                }`}
              >
                {label}
              </th>
            ))}
            {showStoreFees && (
              <th className="py-3.5 px-4 text-left text-sm font-semibold text-slate-900 dark:text-slate-100">
                Store Fees
              </th>
            )}
            {HEADERS_RIGHT.map((label, i) => (
              <th
                key={label}
                className={`py-3.5 px-4 text-left text-sm font-semibold text-slate-900 dark:text-slate-100 ${
                  i === HEADERS_RIGHT.length - 1 ? 'pr-0' : ''
                }`}
              >
                {label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 dark:divide-slate-500">
          {[...Array(rows)].map((_, idx) => (
            <tr key={idx}>
              {widths.slice(0, 6).map((w, i) => (
                <td
                  key={i}
                  className={`whitespace-nowrap py-4 px-4 ${
                    i === 0 ? 'pl-0' : ''
                  }`}
                >
                  <SkeletonBlock className={`h-4 ${w}`} />
                </td>
              ))}
              {showStoreFees && (
                <td className="whitespace-nowrap py-4 px-4">
                  <SkeletonBlock className="h-4 w-16" />
                </td>
              )}
              {widths.slice(6).map((w, i) => (
                <td
                  key={`b-${i}`}
                  className={`whitespace-nowrap py-4 px-4 ${
                    i === widths.slice(6).length - 1 ? 'pr-0' : ''
                  }`}
                >
                  <SkeletonBlock className={`h-4 ${w}`} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default OrdersSummarySkeleton;
